<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Change Status"
            bc1="App"
            bc2="Change Status"
            bc3="Update"
            path="withdrawal-requests"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Change Withdrawal Status</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Source Reference</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="sourceReference"
                                id="name-icon"
                                class="form-control"

                                name="sourceReference"
                                placeholder="Source Reference"

                              />

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Withdrawal status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                v-model="userStatus"
                                size="sm"
                                :class="
                                  errorBag.has('userStatus') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                                name="userStatus"
                                class="form-control"
                              >
                                <option value=""
                                  >Please Select Status
                                </option>
                                <option
                                  v-for="(item, index) in status"
                                  :key="index"
                                  :value="item.id"
                                  >{{ item.text }}
                                </option>
                              </select>
                              <small
                                v-show="errorBag.has('userStatus')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("userStatus") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="userStatus == 4" class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Schema</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                v-model="selectedSchema"
                                size="sm"
                                :class="
                                  errorBag.has('schema') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                                name="schema"
                                class="form-control"
                              >
                                <option
                                  v-for="(item, index) in schemaDetails"
                                  :key="index"
                                  :value="item"
                                  >{{ item.name+'/'+item.code }}
                                </option>
                              </select>
                              <small
                                v-show="errorBag.has('schema')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("schema") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="userStatus == 4" class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Select Acquiring</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                v-model="selectedAcquiring"
                                size="sm"
                                :class="
                                  errorBag.has('acquiring') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                                name="acquiring"
                                class="form-control"
                              >
                                <option value="" disabled>Select Acquiring</option>
                                <option
                                  v-for="(item, index) in acquiringDetails"
                                  :key="index"
                                  :value="item.id"
                                  >{{ item.name+'/'+item.code }}
                                </option>
                              </select>
                              <small
                                v-show="errorBag.has('acquiring')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("acquiring") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 mt-1 mb-1" v-if="userStatus == 4 && isEmpty(chargesDetails)">
                        <button
                            type="button"
                            class="btn btn-warning btn-sm float-right mr-1 d-flex"
                            @click="showCharges"
                        >
                          <Loader :loading="chargesLoader" :size="size"></Loader>
                          Show Charges
                        </button>
                      </div>
                      <div class="col-sm-9 offset-sm-3 mt-1 mb-1" v-if="userStatus == 4">
                        <h6 v-show="!isEmpty(chargesDetails)">Charges Details</h6>
                        <div class="position-relative d-inline-block m-2" v-for="(value,key) in chargesDetails" >
                          <h6 v-if="chargesToShow.includes(key)">{{key}}:<span class="pl-1 text-info">{{parseFloat(value/100).toFixed(feesDecimalPlaces)}}</span></h6>
                        </div>
                        <div class="position-relative d-inline-block m-2" v-if="!isEmpty(chargesDetails)" >
                          <h6>Total:<span class="pl-1 text-info">{{parseFloat(totalCharges/100).toFixed(feesDecimalPlaces)}}</span></h6>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Comment</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-textarea
                                id="textarea-default"
                                placeholder="Add Comment...."
                                rows="3"
                                v-model="comment"

                              />

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Submit
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="Back()"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  props: ['propFilters'],
  mounted() {
    let withdrawalData = this.$store.getters.getByKey("ChangeWithdrawalStatus");
    if (withdrawalData) {
      this.index = withdrawalData.index;
      this.id = withdrawalData.row.id;
      this.currencyId = withdrawalData.row.user_account?withdrawalData.row.user_account.currency_id:null;
      this.getSchemaDetails()

    }
  },
  data() {
    return {
      id: "",
      index: "",
      loading: false,
      size: "10px",
      sourceReference: "",
      comment: "",
      details: "",
      userStatus: "",
      status: [
        { id: 1, text: "Initiate" },
        { id: 3, text: "Reject" },
        { id: 4, text: "Proceed" }
      ],
      currencyId:null,
      schemaDetails:[],
      acquiringDetails:[],
      selectedSchema:[],
      selectedAcquiring:'',
      chargesLoader:false,
      chargesDetails: {},
      chargesToShow:['vaultspay','vat','gateway','other'],
      totalCharges:0
    };
  },
  methods: {
    showCharges(){
      this.chargesLoader = true

      let data = {
        id:this.id,
        status:this.userStatus,
        sourceReferenceId: this.sourceReference,
        comments:this.comment,
        checkCharges:1,
      }

      if(this.userStatus  == 4){
        data.schemaId = this.selectedSchema.id
        data.aquiringId = this.selectedAcquiring
      }

      this.makeRequest(
          "post",
          "v1/change-withdrawal-request-status",
          data
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            this.chargesLoader = false;
            if(callResponse.response.data.data){
              if(typeof(callResponse.response.data.data.allCharges) != 'undefined'){
                this.chargesDetails =  callResponse.response.data.data.allCharges
                Object.keys(this.chargesDetails)
                    .forEach((key) => {
                      if(this.chargesToShow.includes(key)){
                        this.totalCharges = this.totalCharges + parseFloat(this.chargesDetails[key])
                      }
                    });
              }else{
                this.chargesDetails = {}
                this.totalCharges = 0
              }
            }else{
              this.chargesDetails = {}
              this.totalCharges = 0
            }

          } else {
            this.chargesLoader = false;
          }
        }
        this.chargesLoader = false
      });
    },
    Back() {
      let propFilters = this.propFilters
      this.$router.push({name:'withdrawal-requests',params:{propFilters}})
    },
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;


          let data = {
            id:this.id,
            status:this.userStatus,
            sourceReferenceId: this.sourceReference,
            comments:this.comment,
          }

          if(this.userStatus  == 4){
            data.schemaId = this.selectedSchema.id
            data.aquiringId = this.selectedAcquiring
          }

          this.makeRequest(
            "post",
            "v1/change-withdrawal-request-status",
            data
          ).then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.loading = false;
                this.Back()
              } else {
                this.loading = false;
              }
            }
          });
        }
      });
    },
    getSchemaDetails() {
      let data ={
        currencyId  : this.currencyId,
        status:'active',
        aquiring:1
      }
      this.makeRequest("post", "v1/get-schema", data, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.schemaDetails = callResponse.response.data.data
            if(this.schemaDetails){
              this.selectedSchema = this.schemaDetails[0]
            }

          }
        }
      });
    },
  },
  watch:{
    selectedSchema(val){
      if(val){
        this.acquiringDetails = val.aquirings
        if(this.acquiringDetails){
          this.selectedAcquiring = this.acquiringDetails[0].id
        }
      }
    },
    selectedAcquiring(val){
      if(val){
        this.chargesDetails = {}
        this.totalCharges = 0
      }
    }
  }
};
</script>

